import { SVGProps, Ref, forwardRef } from 'react';

export const EmployersRatingFilledSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <path d="M12.25 6a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5" fill="currentColor" />
            <path
                d="M9.793 7.793C9.5 8.086 9.5 8.557 9.5 9.5H7.25c-.943 0-1.414 0-1.707.293s-.293.764-.293 1.707H3c-.943 0-1.414 0-1.707.293S1 12.557 1 13.5v2h14v-6c0-.943 0-1.414-.293-1.707S13.943 7.5 13 7.5h-1.5c-.943 0-1.414 0-1.707.293"
                fill="currentColor"
            />
        </svg>
    )
);
EmployersRatingFilledSize16Glyph.displayName = 'EmployersRatingFilledSize16Glyph';
